import { useSelector } from "react-redux";
import { Star } from "@remo-co/ui-core/src/icons/Star";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { MenuItem } from "@remo-co/ui-core/src/components/MenuItem";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import { selectIsEventManager } from "modules/event/selectors";
import useCompany from "modules/company/hooks/useCompany";
import { useIsInEvent } from "modules/event";
import useConfirmationDialog from "modules/dialogNotification/hooks/useConfirmationDialog";
import { useStartTrial } from "modules/userProfile/hooks/useStartTrial/useStartTrial";
import { selectEnableAgencyWhiteLabelling } from "modules/settings/redux/selectors";
import { useStyles } from "./styles";

export const TrialSignupMenuItem = () => {
  const { t } = useI18n(["menu"]);
  const isEventManager = useSelector(selectIsEventManager);
  const enableAgencyWhiteLabelling = useSelector(
    selectEnableAgencyWhiteLabelling,
  );
  const { company } = useCompany();
  const isInEvent = useIsInEvent();

  const styles = useStyles();
  const { handleStartTrial } = useStartTrial({
    startTrialSource: "user-profile-menu",
  });

  const confirmation = useConfirmationDialog({
    message: t("menu:message.sure"),
  });

  if (isEventManager || company?.id || enableAgencyWhiteLabelling) {
    return null;
  }

  return (
    <MenuItem
      onClick={
        isInEvent ? () => confirmation(handleStartTrial) : handleStartTrial
      }
      data-testid="up-popover-start-trial"
      icon={<Star color="secondary" />}
    >
      <Box className={styles.text}>
        <Typography variant="body1">
          {t("menu:user.menu.start.trial.title")}
        </Typography>
        <Typography variant="caption" className={styles.freeTrialCaption}>
          {t("menu:user.menu.start.trial.subtitle")}
        </Typography>
      </Box>
    </MenuItem>
  );
};
